import type { TCollectionBandsProps } from './CollectionBands.types'

import styles from './CollectionBands.module.css'

export const CollectionBands = ({ hero, children }: TCollectionBandsProps) => (
    <div>
        <div className={styles.heroBand}>{hero}</div>
        <div className={styles.contentBand}>{children}</div>
    </div>
)
